module.exports = __webpack_public_path__ + "static/numbers-10e203963a80c861204198e282e64727.svg";